/**
 * `/admin/portal-documents` — la rotta storica di «Documenti del portale». Dal 03-11-2026 la pagina è
 * `/client-portal-documents`, con la sua voce in «Progetti & clienti»: questa resta per i segnalibri.
 */
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/portal-documents')({
  component: () => <Navigate to="/client-portal-documents" replace />,
});
